import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import store from '@/store';

// import LoginOrSignupLayout from '../layouts/LoginOrSignupLayout.vue';
import PracticeDashboardLayout from '../layouts/PracticeDashboardLayout.vue';
import AdminDashboardLayout from '../layouts/AdminDashboardLayout.vue';
import LocumDashboardLayout from '../layouts/LocumDashboardLayout.vue';
// import UserProfileLayout from '../layouts/UserProfileLayout.vue';
// import UserCompleteProfileLayout from '../layouts/UserCompleteProfileLayout.vue';
import SimpleLayout from '../layouts/SimpleLayout.vue';

import Amplify from 'aws-amplify';

import { getImpersonationData, getImpersonationCache } from '@utils';

Vue.use(VueRouter);

const getPathPrefix = () => {
	const id = store.getters.company.id;
	return {
		pathPrefix: 'companies/' + id,
	};
};

const routes = [
	{
		path: '/',
		name: 'Home',
		meta: { requiresAuth: true },
		beforeEnter: async (to, from, next) => {
			const isManager = await store.dispatch('IsInGroup', 'CompanyAdmin');
			const isLocum = await store.dispatch('IsInGroup', 'Locum');
			const isAdmin = await store.dispatch('IsInGroup', 'SuperAdmin');

			const { isImpersonatedLocum, isImpersonatedPractice } = getImpersonationData(isAdmin);

			if (isManager || isImpersonatedPractice) {
				next('/practice/dashboard');
			} else if (isLocum || isImpersonatedLocum) {
				next('/locum/dashboard');
			} else if (isAdmin) {
				next('/admin/dashboard');
			} else {
				window.location = store.getters.getAUTH;
			}
		},
	},
	// {
	// 	path: '/practice-signup/practice-signup-step-2',
	// 	name: 'PracticeSignupStep2',
	// 	component: () => import('../views/practice/PracticeSignupStep2.vue'),
	// 	meta: { layout: LoginOrSignupLayout, requiresAuth: false },
	// },
	// {
	// 	path: '/practice-user-signup/practice-user-signup',
	// 	name: 'PracticeUserSignup',
	// 	component: () => import('../views/practice-user/PracticeUserSignup.vue'),
	// 	meta: { layout: LoginOrSignupLayout },
	// },
	{
		path: '/locum/profile',
		name: 'LocumProfile',
		component: () => import('../views/LocumEditProfile.vue'),
		meta: { layout: SimpleLayout, requiresAuth: true },
	},
	{
		path: '/locum/account-settings',
		name: 'LocumAccountSettings',
		component: () => import('../components/custom/AccountSettings.vue'),
		meta: { layout: SimpleLayout, requiresAuth: true },
		props: { pathPrefix: 'professionals/profile' },
	},
	{
		path: '/company/profile',
		name: 'CompanyProfile',
		component: () => import('../views/PracticeEditProfile.vue'),
		meta: { layout: SimpleLayout, requiresAuth: true },
	},
	{
		path: '/company/account-settings',
		name: 'CompanyAccountSettings',
		component: () => import('../components/custom/AccountSettings.vue'),
		meta: { layout: SimpleLayout, requiresAuth: true },
		props: getPathPrefix,
	},
	{
		path: '/locum/complete-signup',
		name: 'LocumCompleteSignup',
		component: () => import('../views/LocumCompleteSignup.vue'),
		meta: { layout: SimpleLayout, requiresAuth: true },
	},
	{
		path: '/company/complete-signup',
		name: 'PracticeCompleteSignup',
		component: () => import('../views/PracticeCompleteSignup.vue'),
		meta: { layout: SimpleLayout, requiresAuth: true },
	},
	{
		path: '/locum/verification',
		name: 'LocumVerificationStep',
		component: () => import('../components/locum/profile/VerificationForm.vue'),
		meta: { layout: SimpleLayout, requiresAuth: true },
	},
	{
		path: '/practice/verification',
		name: 'PracticeVerificationStep',
		component: () => import('../components/practice/profile/VerificationForm.vue'),
		meta: { layout: SimpleLayout, requiresAuth: true },
	},
	// {
	// 	path: '/signup',
	// 	name: 'Signup',
	// 	component: () => import('../views/Signup.vue'),
	// 	meta: { layout: LoginOrSignupLayout },
	// },
	// {
	// 	path: '/confirm-signup',
	// 	name: 'ConfirmSignup',
	// 	component: () => import('../views/ConfirmSignup.vue'),
	// 	meta: { layout: LoginOrSignupLayout },
	// },
	// {
	// 	path: '/login',
	// 	name: 'Login',
	// 	component: () => import('../views/Login.vue'),
	// 	meta: { layout: LoginOrSignupLayout },
	// },
	{
		path: '/practice/dashboard',
		name: 'PracticeDashboard',
		component: () => import('../views/dashboard/PracticeDashboard.vue'),
		meta: { layout: PracticeDashboardLayout, requiresAuth: true },
	},
	{
		path: '/admin/dashboard',
		name: 'AdminDashboard',
		beforeEnter: async (to, from, next) => {
			let isAdmin = await store.dispatch('IsInGroup', 'SuperAdmin');
			if (isAdmin) {
				next();
			} else {
				next(from);
			}
		},
		component: () => import('../views/dashboard/AdminDashboard.vue'),
		meta: { layout: AdminDashboardLayout, requiresAuth: false, superAdmin: true },
		props: route => ({
			uID: route.query.uID || null,
			userType: route.query.userType || null,
		}),
	},
	{
		path: '/admin/dashboard/search/bookings',
		name: 'AdminBookingSearch',
		beforeEnter: async (to, from, next) => {
			let isAdmin = await store.dispatch('IsInGroup', 'SuperAdmin');
			if (isAdmin) {
				next();
			} else {
				next(from);
			}
		},
		component: () => import('../views/admin/AdminBookingsSearch.vue'),
		meta: { layout: SimpleLayout, requiresAuth: false, superAdmin: true },
	},
	// {
	// 	path: '/practice/practice-profile',
	// 	name: 'PracticeProfile',
	// 	component: () => import('../views/practice/PracticeProfile.vue'),
	// 	meta: { layout: UserProfileLayout, requiresAuth: false },
	// },
	// {
	// 	path: '/practice-user/practice-user-profile',
	// 	name: 'PracticeUserProfile',
	// 	component: () => import('../views/practice-user/PracticeUserProfile.vue'),
	// 	meta: { layout: UserProfileLayout, requiresAuth: false },
	// },
	// {
	// 	path: '/practice/complete-profile-a',
	// 	name: 'PracticeCompleteProfileA',
	// 	component: () => import('../views/practice/complete-profile/PracticeCompleteProfileA.vue'),
	// 	meta: { layout: UserCompleteProfileLayout, requiresAuth: false },
	// },
	// {
	// 	path: '/practice/complete-profile-b',
	// 	name: 'PracticeCompleteProfileB',
	// 	component: () => import('../views/practice/complete-profile/PracticeCompleteProfileB.vue'),
	// 	meta: { layout: UserCompleteProfileLayout, requiresAuth: false },
	// },
	// {
	// 	path: '/practice/complete-profile-c',
	// 	name: 'PracticeCompleteProfileC',
	// 	component: () => import('../views/practice/complete-profile/PracticeCompleteProfileC.vue'),
	// 	meta: { layout: UserCompleteProfileLayout, requiresAuth: false },
	// },
	// {
	// 	path: '/practice/complete-profile-address',
	// 	name: 'PracticeCompleteProfileAddress',
	// 	component: () => import('../views/practice/complete-profile/PracticeCompleteProfileAddress.vue'),
	// 	meta: { layout: UserCompleteProfileLayout, requiresAuth: false },
	// },
	// {
	// 	path: '/practice/complete-profile-postal-address',
	// 	name: 'PracticeCompleteProfilePostalAddress',
	// 	component: () => import('../views/practice/complete-profile/PracticeCompleteProfilePostalAddress.vue'),
	// 	meta: { layout: UserCompleteProfileLayout, requiresAuth: false },
	// },
	// {
	// 	path: '/practice/complete-profile-open-hours',
	// 	name: 'PracticeCompleteProfileOpenHours',
	// 	component: () => import('../views/practice/complete-profile/PracticeCompleteProfileOpenHours.vue'),
	// 	meta: { layout: UserCompleteProfileLayout, requiresAuth: false },
	// },
	// {
	// 	path: '/practice/complete-profile-avatar-image',
	// 	name: 'PracticeCompleteProfileAvatarImage',
	// 	component: () => import('../views/practice/complete-profile/PracticeCompleteProfileAvatarImage.vue'),
	// 	meta: { layout: UserCompleteProfileLayout, requiresAuth: false },
	// },

	//LOCUM ROUTES

	{
		path: '/locum/dashboard',
		name: 'LocumDashboard',
		component: () => import('../views/dashboard/LocumDashboard.vue'),
		meta: { layout: LocumDashboardLayout, requiresAuth: true },
	},
	{
		path: '/user-unapproved',
		name: 'UserUnapprovedPage',
		component: () => import('../views/UserUnapprovedPage.vue'),
		meta: { layout: SimpleLayout, requiresAuth: true },
	},
	{
		path: '/company/user-management',
		name: 'CompanyUserManagement',
		component: () => import('../views/company/user-management/CompanyUserManagement.vue'),
		meta: { layout: SimpleLayout, requiresAuth: true },
	},
];

//Before any and all axios requests, check if the JWT token is expired and refresh the session if needed.
axios.interceptors.request.use(function (config) {
	return new Promise(resolve => {
		Amplify.Auth.currentSession()
			.then(session => {
				var idTokenExpire = session.getIdToken().getExpiration();
				var refreshToken = session.getRefreshToken();
				var currentTimeSeconds = Math.round(+new Date() / 1000);
				if (idTokenExpire < currentTimeSeconds) {
					Amplify.Auth.currentAuthenticatedUser().then(res => {
						res.refreshSession(refreshToken, (err, data) => {
							if (err) {
								Amplify.Auth.signOut();
							} else {
								store.commit('SET_JWTTOKEN', data.getIdToken().getJwtToken());
								config.headers.Authorization = 'Bearer ' + data.getIdToken().getJwtToken();
								resolve(config);
							}
						});
					});
				} else {
					config.headers.Authorization = 'Bearer ' + session.getIdToken().getJwtToken();
					resolve(config);
				}
			})
			.catch(() => {
				// No logged-in user: don't set auth header
				resolve(config);
			});
	});
});

const router = new VueRouter({
	mode: 'history',
	base: import.meta.env.BASE_URL,
	routes,
});

//before routes duck test each signup step for the user, ensuring that at any time the users profile is complete, \
//  even if new steps are added or current steps are modified.
//if the duck test returns a signup step to move to then redirect user to compelte profile instead of where they were going,
let PRAC_UNAPPROVED = false;
router.beforeEach(async (to, from, next) => {
	let isManager = await store.dispatch('IsInGroup', 'CompanyAdmin');
	let isLocum = await store.dispatch('IsInGroup', 'Locum');
	const { impersonationMode } = getImpersonationCache();

	if (to.matched.some(record => record.meta.requiresAuth) && isLocum) {
		store.dispatch('SET_LAST_ACTIVE_LOCUM');
		let isValid = store.getters.getUserCompletedVerifiedStep;
		if ((!isValid || impersonationMode) && to.path != '/locum/verification') {
			store.commit('SET_CURRENT_ROUTE', '/locum/verification');
			return next('/locum/verification');
		} else if (isValid && store.getters.user && to.path != '/locum/complete-signup') {
			await store.dispatch('UPDATE_NEXT_SIGNUP_STEP');
			let step = store.getters.getNextSignupStep;
			if (step === false) {
				step = store.getters.getNextBoosterSignupStep;
			}
			if (step != false) {
				store.commit('SET_CURRENT_ROUTE', '/locum/complete-signup');
				return next('/locum/complete-signup');
			}
		}
	} else if (to.matched.some(record => record.meta.requiresAuth) && isManager) {
		let isValid = store.getters.getCompanyCompletedVerifiedStep;
		if ((!isValid || impersonationMode) && to.path != '/practice/verification') {
			store.commit('SET_CURRENT_ROUTE', '/practice/verification');
			return next('/practice/verification');
		} else if (isValid && store.getters.company && to.path != '/company/complete-signup') {
			await store.dispatch('UPDATE_NEXT_SIGNUP_STEP_COMPANY');
			let step = store.getters.getNextSignupStepCompany;
			// make sure the company is approved before going anywhere
			if (!store.getters.company.approved && !PRAC_UNAPPROVED) {
				PRAC_UNAPPROVED = true;
				return next('/user-unapproved');
			} else {
				if (step != false) {
					store.commit('SET_CURRENT_ROUTE', '/company/complete-signup');
					return next('/company/complete-signup');
				}
			}
		}
	}

	store.commit('SET_CURRENT_ROUTE', to.path);
	next();
});

export default router;
